import { BAvatar } from './avatar';
import { BAvatarGroup } from './avatar-group';
import { pluginFactory } from '../../utils/plugins';
var AvatarPlugin = /*#__PURE__*/pluginFactory({
  components: {
    BAvatar: BAvatar,
    BAvatarGroup: BAvatarGroup
  }
});
export { AvatarPlugin, BAvatar, BAvatarGroup };


//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/bootstrap-vue@2.23.1_jquery@3.7.1_vue@2.6.14/~/bootstrap-vue/esm/components/avatar/index.js
// module id = xfed
// module chunks = 5